import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { Bot } from "lucide-react";

export const SuretyAutopilotCard = () => {
  const [s, setS] = useState(null);
  const load = () => api.get("/surety/autopilot").then((r) => setS(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!s) return null;
  const toggle = async (on) => {
    try { await api.put("/surety/autopilot", { on }); toast.success(on ? "AI Autopilot is on" : "AI Autopilot is off"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const watch = async (exam_watch) => {
    try { await api.put("/surety/autopilot", { exam_watch }); toast.success(exam_watch ? "Weekday license check is on" : "Weekday license check is off"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <Card className="mb-6 p-6" data-testid="surety-autopilot-card">
      <div className="mb-2 flex flex-wrap items-center justify-between gap-3">
        <h3 className="flex items-center gap-2 font-display text-lg font-bold text-slate-900"><Bot className="h-5 w-5" />AI Autopilot</h3>
        <label className="flex items-center gap-2 text-sm font-semibold"><Switch checked={s.on} onCheckedChange={toggle} data-testid="surety-autopilot-toggle" />{s.on ? "On" : "Off"}</label>
      </div>
      <p className="mb-3 text-sm text-slate-600">While on, Ava sources 5 new contractors licensed in the last week and 5 new exam-eligible applicants every day for free, then calls each lead once a day (leaving a voicemail if no one answers) and texts once a day until they say they're not interested. Every number is checked against the Do-Not-Call lists. Calls go out Mon–Sat, 9 AM–6 PM Eastern. Interested contractors can be transferred to you or booked for a phone, office or business appointment.</p>
      <label className="mb-3 flex items-start gap-2 text-sm text-slate-700"><Switch checked={s.exam_watch} onCheckedChange={watch} data-testid="surety-exam-watch-toggle" className="mt-0.5" />
        <span><b>Weekday license check for exam leads.</b> Every weekday, checks the state licensee list to see if your exam applicants got licensed. When one does, Ava calls you, then calls them to transfer them to you or book a phone or in-business appointment, then calls you back with the result. Turn off to save data.</span></label>
      <div className="flex flex-wrap gap-2 text-xs">
        <Badge variant="outline" data-testid="surety-autopilot-calls">{s.called_today} called today</Badge>
        <Badge variant="outline" data-testid="surety-autopilot-texts">{s.texted_today} texted today</Badge>
        <Badge variant="outline" data-testid="surety-autopilot-appts">{s.appointments} appointments</Badge>
        {!s.dialing && <Badge className="border-0 bg-amber-100 text-amber-800" data-testid="surety-dialing-off">AI dialing is paused by your administrator - texts and emails still go out</Badge>}
      </div>
    </Card>
  );
};
